import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    setContestDialogOpenZajavls,
    setContestEditFormZajavls,
    addContestZajavls
} from '@componentDP/js_react/redux/actions/zajavls';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {configEduLevelsTranslateMap} from "./../../config/edu_levels";
import {configEduFormsTranslateMap} from "./../../config/edu_forms";
import {configSourcesTranslateMap} from "./../../config/sources";
import {configRequirementsTranslateMap} from "./../../config/requirements";
import Grid from '@material-ui/core/Grid';
import {DETAILED_TARGET_SOURCE_ID, TARGET_SOURCE_ID} from '../../constants';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import {filterSprCompetitionsZajavls} from '@helpers/filtering';
import {uniqBy, orderBy, cloneDeep} from 'lodash';
import {withTranslation} from "react-i18next";
import Help from "@material-ui/icons/Help";
import Tooltip from "@material-ui/core/Tooltip";

const contestEditFormZajavlsDefault = {
    edu_level_id: 0,
    competition_group_id: 0,
    form: 0,
    source_id: 0,
    requirement_id: 0,
    target_customer: '',
    for_foreign_citizens: 0,
    is_based_prof_education: 0,
    is_want_use_privilege: 0,
    prior_zachislenia: null,
};

class Contest extends React.Component {
    constructor(props) {
        super(props);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleChangeEduLevel = this.handleChangeEduLevel.bind(this);
        this.handleChangeCompetitionGroup = this.handleChangeCompetitionGroup.bind(this);
        this.handleChangeForm = this.handleChangeForm.bind(this);
        this.handleChangeSource = this.handleChangeSource.bind(this);
        this.handleChangeRequirement = this.handleChangeRequirement.bind(this);
        this.handleChangeTargetCustomer = this.handleChangeTargetCustomer.bind(this);
        this.handleChangeForeign = this.handleChangeForeign.bind(this);
        this.handleChangeProfEdu = this.handleChangeProfEdu.bind(this);
        this.handleWantUsePrivilege = this.handleWantUsePrivilege.bind(this);
        this.handlePriorZachislenia = this.handlePriorZachislenia.bind(this);

        const filteredEduLevel = filterSprCompetitionsZajavls(props.sprCompetitionsZajavls, {});
        const uniqEduLevelList = uniqBy(filteredEduLevel, 'edu_level');
        const orderedEduLevelList = orderBy(uniqEduLevelList, 'edu_level');
        this.state = {
            orderedEduLevelList,
            orderedCompetitionGroupList: [],
            orderedFormList: [],
            orderedSourceList: [],
            orderedRequirementList: [],
            orderedForForeignCitizensList: [],
            orderedForBaseProfEduList: [],
        };
    }
    handleCloseDialog() {
        const {setContestDialogOpenZajavls, setContestEditFormZajavls} = this.props;
        setContestDialogOpenZajavls(false);
        setContestEditFormZajavls(contestEditFormZajavlsDefault);
        this.setState({
            orderedCompetitionGroupList: [],
            orderedFormList: [],
            orderedSourceList: [],
            orderedRequirementList: [],
            orderedForForeignCitizensList: [],
            orderedForBaseProfEduList: [],
        });
    }
    handleAdd() {
        const {addContestZajavls, setContestDialogOpenZajavls, setContestEditFormZajavls, i18n} = this.props;
        const currentLang = i18n.language;
        addContestZajavls(currentLang);
        setContestDialogOpenZajavls(false);
        setContestEditFormZajavls(contestEditFormZajavlsDefault);
        this.setState({
            orderedCompetitionGroupList: [],
            orderedFormList: [],
            orderedSourceList: [],
            orderedRequirementList: [],
            orderedForForeignCitizensList: [],
            orderedForBaseProfEduList: [],
        });
    }

    handleChangeEduLevel(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls, sprCompetitionsZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            edu_level_id: e.target.value,
            competition_group_id: 0,
            form: 0,
            source_id: 0,
            requirement_id: 0,
            target_customer: '',
            for_foreign_citizens: 0,
            is_based_prof_education: 0,
            prior_zachislenia: null,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);

        const filterContainerCompetitionGroup = {
            edu_level: contestEditFormZajavlsModified.edu_level_id,
        };
        const filteredCompetitionGroupList = filterSprCompetitionsZajavls(sprCompetitionsZajavls, filterContainerCompetitionGroup);
        const uniqCompetitionGroupList = uniqBy(filteredCompetitionGroupList, 'competition_group_id');
        const orderedCompetitionGroupList = orderBy(uniqCompetitionGroupList, 'competition_group_id');
        this.setState({
            ...this.state,
            orderedCompetitionGroupList,
            orderedFormList: [],
            orderedSourceList: [],
            orderedRequirementList: [],
            orderedForForeignCitizensList: [],
            orderedForBaseProfEduList: [],
        });
    }
    handleChangeCompetitionGroup(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls, sprCompetitionsZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            competition_group_id: e.target.value,
            form: 0,
            source_id: 0,
            requirement_id: 0,
            target_customer: '',
            for_foreign_citizens: 0,
            is_based_prof_education: 0,
            prior_zachislenia: null,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);

        const filterContainerForm = {
            edu_level: contestEditFormZajavlsModified.edu_level_id,
            competition_group_id: contestEditFormZajavlsModified.competition_group_id,
        };
        const filteredFormList = filterSprCompetitionsZajavls(sprCompetitionsZajavls, filterContainerForm);
        const uniqFormList = uniqBy(filteredFormList, 'form_id');
        const orderedFormList = orderBy(uniqFormList, 'form_id');
        this.setState({
            ...this.state,
            orderedFormList,
            orderedSourceList: [],
            orderedRequirementList: [],
            orderedForForeignCitizensList: [],
            orderedForBaseProfEduList: [],
        });
    }
    handleChangeForm(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls, sprCompetitionsZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            form: e.target.value,
            source_id: 0,
            requirement_id: 0,
            target_customer: '',
            for_foreign_citizens: 0,
            is_based_prof_education: 0,
            prior_zachislenia: null,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);

        const filterContainerSource = {
            edu_level: contestEditFormZajavlsModified.edu_level_id,
            competition_group_id: contestEditFormZajavlsModified.competition_group_id,
            form_id: contestEditFormZajavlsModified.form,
        };
        const filteredSourceList = filterSprCompetitionsZajavls(sprCompetitionsZajavls, filterContainerSource);
        const uniqSourceList = uniqBy(filteredSourceList, 'source_id');
        const orderedSourceList = orderBy(uniqSourceList, 'source_id');
        this.setState({
            ...this.state,
            orderedSourceList,
            orderedRequirementList: [],
            orderedForForeignCitizensList: [],
            orderedForBaseProfEduList: [],
        });
    }
    handleChangeSource(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls, sprCompetitionsZajavls, zajavlsData, zajavlEditUuidZajavls} = this.props;
        let contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            source_id: e.target.value,
            requirement_id: 0,
            target_customer: '',
            for_foreign_citizens: 0,
            is_based_prof_education: 0,
            prior_zachislenia: null,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);

        const filterContainerRequirement = {
            edu_level: contestEditFormZajavlsModified.edu_level_id,
            competition_group_id: contestEditFormZajavlsModified.competition_group_id,
            form_id: contestEditFormZajavlsModified.form,
            source_id: contestEditFormZajavlsModified.source_id,
        };
        const filteredRequirementList = filterSprCompetitionsZajavls(sprCompetitionsZajavls, filterContainerRequirement);
        const uniqRequirementList = uniqBy(filteredRequirementList, 'requirement_id');
        const orderedRequirementList = orderBy(uniqRequirementList, 'requirement_id');

        const uniqForForeignCitizensList = uniqBy(filteredRequirementList, 'for_foreign_citizens');
        const orderedForForeignCitizensList = orderBy(uniqForForeignCitizensList, 'for_foreign_citizens');

        const uniqForBaseProfEduList = uniqBy(filteredRequirementList, 'is_based_prof_education');
        const orderedForBaseProfEduList = orderBy(uniqForBaseProfEduList, 'is_based_prof_education');


        this.setState({
            ...this.state,
            orderedRequirementList,
            orderedForForeignCitizensList,
            orderedForBaseProfEduList,
        });

        //автовыбор Требование к уровню образования
        if (orderedRequirementList.length === 1) {
            contestEditFormZajavlsModified = {
                ...contestEditFormZajavlsModified,
                requirement_id: orderedRequirementList[0].requirement_id,
            }
            setContestEditFormZajavls(contestEditFormZajavlsModified);
            if (orderedForForeignCitizensList.length === 1) {
                contestEditFormZajavlsModified = {
                    ...contestEditFormZajavlsModified,
                    for_foreign_citizens: orderedForForeignCitizensList[0].for_foreign_citizens,
                };
                setContestEditFormZajavls(contestEditFormZajavlsModified);
            }
        }
    }
    handleChangeRequirement(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls, sprCompetitionsZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            requirement_id: e.target.value,
            target_customer: '',
            for_foreign_citizens: 0,
            is_based_prof_education: 0,
            prior_zachislenia: null,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);

        const filterContainerForForeignCitizens = {
            edu_level: contestEditFormZajavlsModified.edu_level_id,
            competition_group_id: contestEditFormZajavlsModified.competition_group_id,
            form_id: contestEditFormZajavlsModified.form,
            source_id: contestEditFormZajavlsModified.source_id,
            requirement_id: contestEditFormZajavlsModified.requirement_id,
        };
        const filteredForForeignCitizensList = filterSprCompetitionsZajavls(sprCompetitionsZajavls, filterContainerForForeignCitizens);
        const uniqForForeignCitizensList = uniqBy(filteredForForeignCitizensList, 'for_foreign_citizens');
        const orderedForForeignCitizensList = orderBy(uniqForForeignCitizensList, 'for_foreign_citizens');

        const uniqForBaseProfEduList = uniqBy(filteredForForeignCitizensList, 'is_based_prof_education');
        const orderedForBaseProfEduList = orderBy(uniqForBaseProfEduList, 'is_based_prof_education');

        this.setState({
            ...this.state,
            orderedForForeignCitizensList,
            orderedForBaseProfEduList
        });

        //автовыбор Конкурс только для иностранцев
        if (orderedForForeignCitizensList.length === 1) {
            setContestEditFormZajavls({
                ...contestEditFormZajavlsModified,
                for_foreign_citizens: orderedForForeignCitizensList[0].for_foreign_citizens,
            });
        }
    }

    handlePriorZachislenia(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            prior_zachislenia: e.target.value,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);
    }

    handleChangeTargetCustomer(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            target_customer: e.target.value,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);
    }
    handleChangeForeign(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            for_foreign_citizens: e.target.checked ? 1 : 0,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);
    }

    handleChangeProfEdu(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            is_based_prof_education: e.target.checked ? 1 : 0,
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);
    }

    handleWantUsePrivilege(e) {
        const {setContestEditFormZajavls, contestEditFormZajavls} = this.props;
        const contestEditFormZajavlsModified = {
            ...contestEditFormZajavls,
            is_want_use_privilege: (e.target.checked ? 1 : 0),
        };
        setContestEditFormZajavls(contestEditFormZajavlsModified);
    }

    render() {
        const {
            classes,
            contestDialogOpenZajavls,
            contestEditFormZajavls,
            sprAllowedForAdmissionCompGroupsNames,
            t,
            i18n
        } = this.props;
        const {
            handleCloseDialog,
            handleAdd,
            handleChangeEduLevel,
            handleChangeCompetitionGroup,
            handleChangeForm,
            handleChangeSource,
            handleChangeRequirement,
            handleChangeTargetCustomer,
            handleChangeForeign,
            handleChangeProfEdu,
            handleWantUsePrivilege,
            handlePriorZachislenia
        } = this;
        const {
            orderedEduLevelList,
            orderedCompetitionGroupList,
            orderedFormList,
            orderedSourceList,
            orderedRequirementList,
            orderedForForeignCitizensList,
            orderedForBaseProfEduList,
        } = this.state;
        const currentLang = i18n.language;
        const isNeedShowBaseProfEdu = orderedForBaseProfEduList.some(
            item => item.is_based_prof_education === 1
        );

        return(
            <Dialog open={contestDialogOpenZajavls} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{t('adding_competition')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel id="edu_level" required>{t('edu_level')}</InputLabel>
                                <Select
                                    labelId="edu_level"
                                    label={t('edu_level')}
                                    value={contestEditFormZajavls.edu_level_id ? contestEditFormZajavls.edu_level_id : 0}
                                    onChange={handleChangeEduLevel} >
                                    <MenuItem value={0}>{t('not_selected')}</MenuItem>
                                    {orderedEduLevelList.map((orderedEduLevel) => {
                                        return (
                                            <MenuItem value={orderedEduLevel.edu_level} key={orderedEduLevel.edu_level}>
                                                {configEduLevelsTranslateMap[orderedEduLevel.edu_level]
                                                    ? t(configEduLevelsTranslateMap[orderedEduLevel.edu_level])
                                                    : `${t('title_not_found')} (ID ${orderedEduLevel.edu_level})`}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel id="competition_group_id" required>{t('competition_group_id')}</InputLabel>
                                <Select
                                    labelId="competition_group_id"
                                    label={t('competition_group_id')}
                                    value={contestEditFormZajavls.competition_group_id ? contestEditFormZajavls.competition_group_id : 0}
                                    onChange={handleChangeCompetitionGroup}
                                >
                                    <MenuItem value={0}>{t('not_selected')}</MenuItem>
                                    {orderedCompetitionGroupList.map((orderedCompetitionGroup) => {
                                        const compGroupId = orderedCompetitionGroup.competition_group_id;
                                        const compGroup = sprAllowedForAdmissionCompGroupsNames[compGroupId];
                                        const label =
                                            compGroup
                                                ? currentLang === 'en'
                                                    ? compGroup.value_en || compGroup.value
                                                    : compGroup.value
                                                : `${t('title_not_found')} (ID ${compGroupId})`;
                                        return (
                                            <MenuItem value={compGroupId} key={compGroupId}>
                                                {label}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel id="form" required>{t('form')}</InputLabel>
                                <Select
                                    labelId="form"
                                    label={t('form')}
                                    value={contestEditFormZajavls.form ? contestEditFormZajavls.form : 0}
                                    onChange={handleChangeForm}
                                >
                                    <MenuItem value={0}>{t('not_selected')}</MenuItem>
                                    {orderedFormList.map((orderedFormList) => {
                                        return (
                                            <MenuItem value={orderedFormList.form_id} key={orderedFormList.form_id}>
                                                {configEduFormsTranslateMap[orderedFormList.form_id]
                                                    ? t(configEduFormsTranslateMap[orderedFormList.form_id])
                                                    : `${t('title_not_found')} (ID ${orderedFormList.form_id})`}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel id="source_id" required>{t('source_id')}</InputLabel>
                                <Select
                                    labelId="source_id"
                                    label={t('source_id')}
                                    value={contestEditFormZajavls.source_id ? contestEditFormZajavls.source_id : 0}
                                    onChange={handleChangeSource}
                                >
                                    <MenuItem value={0}>{t('not_selected')}</MenuItem>
                                    {orderedSourceList.map((orderedSource) => {
                                        return (
                                            <MenuItem value={orderedSource.source_id} key={orderedSource.source_id}>
                                                {configSourcesTranslateMap[orderedSource.source_id]
                                                    ? t(configSourcesTranslateMap[orderedSource.source_id])
                                                    : `${t('title_not_found')} (ID ${orderedSource.source_id})`}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        {contestEditFormZajavls.source_id && (contestEditFormZajavls.source_id === TARGET_SOURCE_ID || contestEditFormZajavls.source_id === DETAILED_TARGET_SOURCE_ID)
                            ? <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    label={t('target_customer')}
                                    onChange={handleChangeTargetCustomer}
                                    required/>
                            </Grid>
                            : null}
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth>
                                <InputLabel id="requirement_id" required>{t('requirement_id')}</InputLabel>
                                <Select
                                    labelId="requirement_id"
                                    label={t('requirement_id')}
                                    value={contestEditFormZajavls.requirement_id ? contestEditFormZajavls.requirement_id : 0}
                                    onChange={handleChangeRequirement}
                                    disabled={orderedRequirementList.length === 1} >
                                    <MenuItem value={0}>{t('not_selected')}</MenuItem>
                                    {orderedRequirementList.map((orderedRequirement) => {
                                        return (
                                            <MenuItem value={orderedRequirement.requirement_id} key={orderedRequirement.requirement_id}>
                                                {configRequirementsTranslateMap[orderedRequirement.requirement_id]
                                                    ? t(configRequirementsTranslateMap[orderedRequirement.requirement_id])
                                                    : `${t('title_not_found')} (ID ${orderedRequirement.requirement_id})`}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl size="small" variant="outlined" fullWidth >
                                <InputLabel id="prior_zachislenia">{t('prior_zachislenia')}</InputLabel>
                                <Select
                                    labelId="prior_zachislenia"
                                    label={t('prior_zachislenia')}
                                    value={contestEditFormZajavls.prior_zachislenia ? contestEditFormZajavls.prior_zachislenia : 0}
                                    onChange={handlePriorZachislenia}
                                    disabled={!([3, 5, 24].includes(contestEditFormZajavls.edu_level_id))}>
                                    <MenuItem value={0}>{t('not_selected')}</MenuItem>
                                    {Array(9).fill(null).map((_, i) => {
                                        return (
                                            <MenuItem key={i+1} value={i+1}>
                                                {i+1}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={Boolean(contestEditFormZajavls.for_foreign_citizens)}
                                        onChange={handleChangeForeign}
                                        color="primary"
                                        disabled={orderedForForeignCitizensList.length === 1}
                                    />
                                }
                                label={t('for_foreign_citizens')} />
                        </Grid>

                        {isNeedShowBaseProfEdu && (
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={Boolean(contestEditFormZajavls.is_based_prof_education)}
                                            onChange={handleChangeProfEdu}
                                            color="primary"
                                        />
                                    }
                                    label={
                                        <span>
                                            {t('is_based_prof_education')}
                                            <Tooltip
                                                title={
                                                    <span className={classes.helperTooltipTextSize}>
                                                        {t('tooltip_is_base_prof_edu')}
                                                    </span>
                                                }
                                            >
                                                <Help className={classes.helperTooltipIconSize} />
                                            </Tooltip>
                                        </span>
                                    }
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={Boolean(contestEditFormZajavls.is_want_use_privilege)}
                                        onChange={handleWantUsePrivilege}
                                        color="primary"
                                    />
                                }
                                label={t('is_want_use_privilege')} />
                        </Grid>

                    </Grid>
                    {/*<DialogContentText>*/}
                    {/*    To subscribe to this website, please enter your email address here. We will send updates*/}
                    {/*    occasionally.*/}
                    {/*</DialogContentText>*/}
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleCloseDialog}>
                        {t('cancel')}
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleAdd}
                        disabled={
                            !contestEditFormZajavls.edu_level_id
                            || !contestEditFormZajavls.competition_group_id
                            || !contestEditFormZajavls.form
                            || !contestEditFormZajavls.source_id
                            || !contestEditFormZajavls.requirement_id
                            || (contestEditFormZajavls.source_id === TARGET_SOURCE_ID || contestEditFormZajavls.source_id === DETAILED_TARGET_SOURCE_ID)
                                && !contestEditFormZajavls.target_customer}>
                        {t('add')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

function mapStateToProps(state) {
    return {
        contestDialogOpenZajavls: cloneDeep(state.contestDialogOpenZajavls),
        contestEditFormZajavls: cloneDeep(state.contestEditFormZajavls),
        sprCompetitionsZajavls: cloneDeep(state.sprCompetitionsZajavls),
        zajavlEditUuidZajavls: cloneDeep(state.zajavlEditUuidZajavls),
        zajavlsData: cloneDeep(state.zajavls),
        sprAllowedForAdmissionCompGroupsNames: cloneDeep(state.sprAllowedForAdmissionCompGroupsNames),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setContestDialogOpenZajavls,
        setContestEditFormZajavls,
        addContestZajavls,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Contest));
